module.exports = __webpack_public_path__ + "static/img/icon12.7279d94.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon12.png
// module id = S3M3
// module chunks = 9